// extracted by mini-css-extract-plugin
module.exports = {"form":"EditProjectNoteForm_form__2dICA","textarea":"EditProjectNoteForm_textarea__2KxWH"};